const windowOpen = (link: string | undefined): void => {
  if (typeof window !== 'undefined' && link?.length) {
    window.open(link, '_blank');
  }
};

export const RoutingUtils = {
  windowOpen,
};
